/**
 * Author:hong.rong
 * Desc: 从网盘选择
 * Date:2022-09-15
 */

import React from 'react'
import classNames from 'classnames'
import { Breadcrumb, Input, Table } from 'antd'
import { FileHelper } from '@/libs/common'
import dayjs from '@/utils/dayjs'
import IconSvg from '@/components/IconSvg'
import { fileMap, fileTypeToNumber } from '../../utils'
require('./index.less')

export default function Index(props) {
  const {
    loading,
    accept,
    breadList,
    dataSource,
    isExceed,
    selectedRows,
    onBreadClick,
    onFolderClick,
    onSearch,
    onRowSelect,
    translateTxt,
  } = props

  const columns = [
    {
      title: translateTxt('components:panDisk.t3'),
      dataIndex: 'name',
      width: 200,
      className: 'file-name',
      ellipsis: true,
      render: (text, row, index) => {
        const fileType = (row.fileType || '').toLowerCase()
        return row.fileType === 'DIR' ? (
          <span className="folder file-icon-wrap" onClick={() => onFolderClick(row, index)}>
            <span className="file-icon">
              <IconSvg
                type={
                  fileMap[fileTypeToNumber(fileType, FileHelper.getType(text.split('.').pop()))]
                }
                style={{ width: 22, height: 22 }}
              />
            </span>
            <span className="name-text-wrap"> {text}</span>
          </span>
        ) : (
          <div className="file-icon-wrap">
            <span className="file-icon">
              <IconSvg
                type={
                  fileMap[fileTypeToNumber(fileType, FileHelper.getType(text.split('.').pop()))]
                }
                style={{ width: 22, height: 22 }}
              />
            </span>
            <span className="name-text-wrap"> {text}</span>
          </div>
        )
      },
    },
    {
      title: translateTxt('components:panDisk.t4'),
      dataIndex: 'size',
      width: 100,
      render: (text, record) => (
        <span> {record.size ? FileHelper.formatSize(record.size) : '-'}</span>
      ),
    },
    {
      title: translateTxt('components:panDisk.t5'),
      dataIndex: 'createTime',
      width: 100,
      render: t => (t > 0 ? dayjs(t).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
  ]

  return (
    <div className="material-library">
      <div className="material-library-search">
        <div />
        <div className="material-library-input">
          <Input
            allowClear
            placeholder={translateTxt('components:panDisk.t6')}
            prefix={<IconSvg type="icon-sousuo" />}
            style={{ width: 278 }}
            onPressEnter={(e: any) => onSearch(e.target.value)}
          />
        </div>
      </div>
      <div className="material-library-bar">
        <div className="material-library-bread">
          {/* @ts-ignore */}
          <Breadcrumb separator=">" className="breadcrumb-content" id="breadcrumb-content">
            {breadList.map((b, breadIndex) => {
              return (
                <Breadcrumb.Item
                  key={breadIndex}
                  onClick={() => {
                    if (!isExceed) {
                      onBreadClick(b, breadIndex)
                    } else {
                      breadIndex === 0 && onBreadClick(b, breadIndex)
                    }
                  }}
                  className={classNames('breadcrumb-item', {
                    'breadcrumb-first-item': breadIndex === 0,
                    'breadcrumb-ellipsis-item': b.value === 'ellipsis',
                    folder: !isExceed || (isExceed && breadIndex === 0),
                  })}
                >
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {breadIndex === 0
                    ? b.name === '/'
                      ? translateTxt('components:panDisk.t2')
                      : b.name
                    : b.name || '-'}
                </Breadcrumb.Item>
              )
            })}
          </Breadcrumb>
        </div>
        <div>
          {!loading ? (
            <span>
              {translateTxt('components:panDisk.t7')} {dataSource.length}
            </span>
          ) : (
            `${translateTxt('components:t43')}...`
          )}
        </div>
      </div>
      <div className="material-library-list">
        <Table
          sticky
          locale={{ emptyText: translateTxt('components:t202') }}
          loading={loading}
          rowSelection={{
            onChange: (_, rows) => onRowSelect(rows),
            getCheckboxProps: record => ({
              disabled:
                (record.fileType || '').toLowerCase() === 'dir' ||
                !accept.includes(record.fileExtension),
            }),
            selectedRowKeys: selectedRows.map(m => m.uuid),
          }}
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          bordered={false}
          size="middle"
          // tableLayout="fixed"
          rowKey="uuid"
        />
      </div>
    </div>
  )
}
